import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IBarContainerProps {
  height?: number;
};

export const Root = styled.div`
  width: 321px;
  min-height: 10px;
  display: flex;
  flex-direction:column; 
  padding: 0 0 11px;
  border-radius: 5px;
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(130, 130, 130, 0.5);
  background-color: var(--white);
  padding: 8px 9px 0px 9px;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`

export const Input = styled.input`
  display: flex;
  padding: 0px 12px 8px 12px;
  font-family: Roboto;
  font-size: 12px;
  color: #202020;
  background-color: transparent;
  outline: none;
  border: none;
  flex-grow: 1 
`;